import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

export default function Error404() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="h-auto bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white flex flex-col items-center justify-center px-4 py-12">
      <div className="text-center space-y-6">
        <div className="text-8xl font-extrabold text-red-500 drop-shadow-md animate-pulse">404</div>

        <h1 className="text-3xl md:text-4xl font-bold">
          {t("404.oops") || "Oops! Page not found."}
        </h1>

        <p className="text-lg text-gray-300">
          {t("404.doesNotExist") || "The page you’re looking for doesn’t exist or has been moved."}
        </p>

        <p className="text-sm text-gray-500 italic">Path: {location.pathname}</p>

        <img
          src={`${process.env.REACT_APP_SMIK_API_BASEURL}/empty-boxes.svg`}
          alt="Empty Box"
          className="mx-auto w-60 md:w-72 mt-4 animate-bounce-slow"
        />

        <div className="mt-6">
          <Link
            to="/dashboard"
            className="inline-block px-6 py-3 bg-white text-black font-semibold rounded-full shadow-md hover:bg-red-500 hover:text-white transition-all"
          >
            ⬅ {t("404.backToDash") || "Back to Dashboard"}
          </Link>
        </div>
      </div>
    </div>
  );
}
